import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { AppError, MapDataLayer } from '@core/api';

export const dataLayersActions = createActionGroup({
  source: 'Map/Data Layers',
  events: {
    'Fetch Data Layers': emptyProps(),
    'Fetch Data Layers Success': props<{ dataLayers: MapDataLayer[] }>(),
    'Fetch Data Layers Fails': props<{ error: AppError }>(),
    'Add Layer To Favourites': props<{ id: string }>(),
    'Add Layer To Favourites Success': props<{ id: string }>(),
    'Add Layer To Favourites Fail': props<{ error: AppError }>(),
    'Remove Layer From Favourites': props<{ id: string }>(),
    'Remove Layer From Favourites Success': props<{ id: string }>(),
    'Remove Layer From Favourites Fail': props<{ error: AppError }>(),
    'Update Data Layer Opacity': props<{ id: string; opacity: number }>(),
    'Update Data Layer Opacity Success': props<{ ids: string[] }>(),
    'Update Data Layer Opacity Fail': props<{ error: AppError }>(),
    'Show Data Layer': props<{ id: string; zoom?: number }>(),
    'Show Data Layer Success': props<{ ids: string[] }>(),
    'Show Data Layer Fail': props<{ error: AppError }>(),
    'Hide Data Layer': props<{ id: string; zoom?: number }>(),
    'Hide Data Layer Success': props<{ ids: string[] }>(),
    'Hide Data Layer Fail': props<{ error: AppError }>(),
    'Hide All Data Layers': emptyProps(),
  },
});
